import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader.js";
import { BACKEND_URL } from "../../config/config";
import axios from "axios";
import { ContractsList } from "../../components/Contract/ContractsList/ContractsList";
import { useAuth } from "../../hooks";
import { useNotification } from "../../context/NotificationContext.js";

export function Contracts() {
  const [isLoading, setIsLoading] = useState(false);
  const [contracts, setContracts] = useState([]);
  const { user } = useAuth();
  const [reload, setReload] = useState(false);
  const { notification } = useNotification();
  const location = useLocation();

  const getData = async () => {
    setIsLoading(true);

    const url = `${BACKEND_URL}/customers/getParc360ContractsByContactID?contact=${user._id}`;

    const response = await axios.get(url).catch((err) => console.log(err));

    console.log("Contracts retrieved: ", response.data.contracts, user._id);
    if (response?.data) {
      setContracts(response.data.contracts || []);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      console.log("No data retrieved");
    }
  };

  const handleRefreshChange = () => {
    getData();
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, reload]);

  // Refreshes this list when a push notification arrives while the tab is
  // open (e.g. a new PARC 360 contract), same signal MenuTop/Notifications
  // already use for the unread badge/list.
  useEffect(() => {
    if (notification) {
      setReload((r) => !r);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification]);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", paddingTop: "1rem" }}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <ContractsList
          title="PARC 360 Contracts Pending Approval"
          contracts={contracts}
          setReload={setReload}
          reload={reload}
          handleRefreshChange={handleRefreshChange}
          autoOpenContractId={location.state?.openContractId}
        />
      )}
    </div>
  );
}
